export const ADDITIONAL_INFORMATION_DIVIDER = ',,,'
